<div class="container">
  <div class="col-md-12">
    <legend>Product Qualifications</legend>
    <div class="btnRig">
      <a (click)="viewDetail(null)">
        <button id="add" name="add" class="btn btn-primary" *ngIf="hasPermission('ProductsChange')">
          Add
        </button>
      </a>
    </div>
    <div style="display: inline-block">
      <p-table
        class="table-dark"
        #dtProductQualificationTable
        [columns]="colsProductQualification"
        [value]="productQualifications"
        [autoLayout]="true"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns">
              {{ col.header }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pq>
          <tr class="clickable-row" (dblclick)="viewDetail(pq)">
            <td>{{ pq.name }}</td>
            <td>{{ pq.avatarFieldName }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Modal -->
<div
  class="modal fade"
  id="addProductQualificationModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="addProductQualificationLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addProductQualificationLabel">
          {{
            selProductQualification && selProductQualification.id
              ? "Product Qualification Details"
              : "Add New Product Qualification"
          }}
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="selProductQualification">
        <div *ngIf="modalError.length" class="alert alert-block alert-danger">
          {{ modalError }}
        </div>
        <div>
          <div class="form-group row">
            <label class="col-sm-4 control-label">Name</label>
            <div class="col-sm-8">
              <input
                id="name"
                name="name"
                type="text"
                [disabled]="is_edit"
                [(ngModel)]="selProductQualification.name"
                placeholder="Enter display name (e.g., LPG, Liquid Hydrogen)"
                class="form-control"
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 control-label">Avatar Field Name</label>
            <div class="col-sm-8">
              <input
                id="avatarFieldName"
                name="avatarFieldName"
                type="text"
                [disabled]="is_edit"
                [(ngModel)]="selProductQualification.avatarFieldName"
                placeholder="Enter Avatar API field name (e.g., lpg, liquid_hydrogen)"
                class="form-control"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="modalElem btn btn-secondary" data-dismiss="modal">
          Cancel
        </button>
        <button
          type="button"
          class="modalElem btn btn-warning"
          (click)="enableEdit()"
          *ngIf="
            hasPermission('ProductsChange') &&
            selProductQualification &&
            selProductQualification.id &&
            is_edit
          "
        >
          Edit
        </button>
        <button
          type="button"
          class="modalElem btn btn-danger"
          (click)="delete()"
          [attr.data-dismiss]="!modalError.length ? 'modal' : ''"
          *ngIf="
            hasPermission('ProductsChange') && selProductQualification && selProductQualification.id
          "
        >
          Delete
        </button>
        <button
          type="button"
          class="modalElem btn btn-primary"
          (click)="editOn()"
          [attr.data-dismiss]="!modalError.length ? 'modal' : ''"
          *ngIf="hasPermission('ProductsChange') && !is_edit"
        >
          {{ btn }}
        </button>
      </div>
    </div>
  </div>
</div>
